import React, { useEffect, useState } from 'react';
import Header from './components/header/header.jsx';
import TopNav from './components/top-nav/top-nav.jsx';
import Sidebar from './components/sidebar/sidebar.jsx';
import Content from './components/content/content.jsx';
import Footer from './components/footer/footer.jsx';
import ThemePanel from './components/theme-panel/theme-panel.jsx';
import { AppSettings } from './config/app-settings.js';

function App() {
  var defaultOptions = {
    appMode: 'light',
    appTheme: 'theme-gray-800',
    appCover: 'bg-cover-8',
    appHeaderNone: false,
    appSidebarNone: false,
    appSidebarCollapsed: false,
    appContentNone: false,
    appContentClass: '',
    appContentFullHeight: false,
    appBoxedLayout: false,
    appFooter: false,
    appTopNav: false
  };
  const [appHeaderNone, setAppHeaderNone] = useState(defaultOptions.appHeaderNone);
  const [appSidebarNone, setAppSidebarNone] = useState(defaultOptions.appSidebarNone);
  const [appSidebarCollapsed, setAppSidebarCollapsed] = useState(defaultOptions.appSidebarCollapsed);
  const [appContentNone, setAppContentNone] = useState(defaultOptions.appContentNone);
  const [appContentClass, setAppContentClass] = useState(defaultOptions.appContentClass);
  const [appContentFullHeight, setAppContentFullHeight] = useState(defaultOptions.appContentFullHeight);
  const [appBoxedLayout, setAppBoxedLayout] = useState(defaultOptions.appBoxedLayout);
  const [appFooter, setAppFooter] = useState(defaultOptions.appFooter);
  const [appTopNav, setAppTopNav] = useState(defaultOptions.appTopNav);
  const providerValue = {
    setAppHeaderNone,
    setAppSidebarNone,
    setAppSidebarCollapsed,
    setAppContentNone,
    setAppContentClass,
    setAppContentFullHeight,
    setAppBoxedLayout,
    setAppFooter,
    setAppTopNav
  };

  useEffect(() => {
    // 1. Mode (light/dark)
    const mode = (localStorage.appMode !== undefined) ? localStorage.appMode : defaultOptions.appMode;
    document.documentElement.setAttribute('data-bs-theme', mode);

    // 2. Theme color
    const theme = (localStorage.appTheme !== undefined) ? localStorage.appTheme : defaultOptions.appTheme;
    document.body.className = document.body.className
      .split(" ")
      .filter(c => !c.startsWith("theme-"))
      .join(" ");
    if (theme) document.body.classList.add(theme);

    // 3. Cover background (No BG = '')
  const cover = (typeof localStorage.appCover !== "undefined") ? localStorage.appCover : defaultOptions.appCover;
  document.documentElement.className = document.documentElement.className
    .split(" ")
    .filter(c => !c.startsWith("bg-cover-") && c !== 'no-bg-cover')
    .join(" ");
  if (cover) {
    document.documentElement.classList.add(cover);
    document.documentElement.classList.remove('no-bg-cover');
  } else {
    document.documentElement.classList.add('no-bg-cover');
  }
  }, []);

  return (
    <AppSettings.Provider value={providerValue}>
      <div className={
        'app ' +
        (appBoxedLayout ? 'app-boxed-layout ' : '') +
        (appContentFullHeight ? 'app-content-full-height ' : '') +
        (appHeaderNone ? 'app-without-header ' : '') +
        (appSidebarNone ? 'app-without-sidebar ' : '') +
        (appSidebarCollapsed ? 'app-sidebar-collapsed ' : '') +
        (appFooter ? 'app-footer-fixed ' : '') +
        (appTopNav ? 'app-with-top-nav ' : '')
      }>
        {!appHeaderNone && (<Header />)}
        {appTopNav && (<TopNav />)}
        {!appSidebarNone && (<Sidebar />)}
        {!appContentNone && (<Content className={appContentClass} />)}
        {appFooter && (<Footer />)}
        <ThemePanel />
      </div>
    </AppSettings.Provider>
  )
}

export default App;
